import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { Banco } from 'src/app/Models/planilla/banco';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-bancos',
  templateUrl: './bancos.component.html',
  styleUrls: ['./bancos.component.css']
})
export class BancosComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: Banco[] = [];
  public nuevo: Banco   = new Banco();
  public agregando      = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Bancos | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.banco, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.banco);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new Banco(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new Banco(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.banco, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new Banco(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: Banco)  { this._backup[item.idbanco] = { ...item }; item.editando = true; }
  CancelEdit(item: Banco) { Object.assign(item, this._backup[item.idbanco]); item.editando = false; }

  SaveEdit(item: Banco) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.banco, `${item.idbanco}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idbanco]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: Banco) {
    this.info.show(`¿Deseas eliminar el banco "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: Banco) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.banco, `${item.idbanco}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
